/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React from "react";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "./styles.css";

// import required modules
import { Pagination } from "swiper/modules";

function DesktopSlider() {
  return (
    <>
      <Swiper
        direction={"vertical"}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div class="hero-single">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-md-12 col-lg-6" style={{ marginLeft: "-40px" }}>
                  <div class="hero-content">
                    <h6
                      class="hero-sub-title"
                      data-animation="fadeInUp"
                      data-delay=".25s"
                    >
                      Buy with Confidence!
                    </h6>
                    <h1
                      class="hero-title"
                      data-animation="fadeInRight"
                      data-delay=".50s"
                    >
                      Get Dealer-Level Access To Used Car Auctions
                    </h1>
                    <p className="ps-5 pe-5" data-animation="fadeInLeft" data-delay=".75s">
                      Let’s help you Buy, Ship and Clear your dream car at a
                      fraction of the retail cost.
                    </p>
                    <div
                      class="hero-btn"
                      data-animation="fadeInUp"
                      data-delay="1s"
                    >
                      <a href="/profile.html" class="theme-btn">
                        Contact Us<i class="fas fa-arrow-right-long"></i>
                      </a>
                      <a href="/buyvehiclesteps" class="theme-btn theme-btn2">
                        Learn More<i class="fas fa-arrow-right-long"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-6">
                  <div class="hero-right">
                    <div class="hero-img">
                      <img
                        src="/assets/img/slider/Homepage Banner 01.jpg"
                        alt
                        data-animation="fadeInRight"
                        data-delay=".25s"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div class="hero-single">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-md-12 col-lg-6" style={{ marginLeft: "-40px" }}>
                  <div class="hero-content">
                    <h6
                      class="hero-sub-title"
                      data-animation="fadeInUp"
                      data-delay=".25s"
                    >
                      Buy with Confidence!
                    </h6>
                    <h1
                      class="hero-title"
                      data-animation="fadeInRight"
                      data-delay=".50s"
                    >
                      Get Dealer-Level Access To Used Car Auctions
                    </h1>
                    <p className="ps-5 pe-5" data-animation="fadeInLeft" data-delay=".75s">
                      Let’s help you Buy, Ship and Clear your dream car at a
                      fraction of the retail cost.
                    </p>
                    <div
                      class="hero-btn"
                      data-animation="fadeInUp"
                      data-delay="1s"
                    >
                      <a href="#" class="theme-btn">
                        About More<i class="fas fa-arrow-right-long"></i>
                      </a>
                      <a href="#" class="theme-btn theme-btn2">
                        Learn More<i class="fas fa-arrow-right-long"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-6">
                  <div class="hero-right">
                    <div class="hero-img">
                      <img
                        src="/assets/img/slider/Homepage Banner 02.jpg"
                        alt
                        data-animation="fadeInRight"
                        data-delay=".25s"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div class="hero-single">
            <div class="container">
              <div class="row align-items-center">
                <div class="col-md-12 col-lg-6" style={{ marginLeft: "-40px" }}>
                  <div class="hero-content">
                    <h6
                      class="hero-sub-title"
                      data-animation="fadeInUp"
                      data-delay=".25s"
                    >
                      Buy with Confidence!
                    </h6>
                    <h1
                      class="hero-title"
                      data-animation="fadeInRight"
                      data-delay=".50s"
                    >
                      Get Dealer-Level Access To Used Car Auctions
                    </h1>
                    <p className="ps-5 pe-5" data-animation="fadeInLeft" data-delay=".75s">
                      Let’s help you Buy, Ship and Clear your dream car at a
                      fraction of the retail cost.
                    </p>
                    <div
                      class="hero-btn"
                      data-animation="fadeInUp"
                      data-delay="1s"
                    >
                      <a href="#" class="theme-btn">
                        About More<i class="fas fa-arrow-right-long"></i>
                      </a>
                      <a href="#" class="theme-btn theme-btn2">
                        Learn More<i class="fas fa-arrow-right-long"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-lg-6">
                  <div class="hero-right">
                    <div class="hero-img">
                      <img
                        src="/assets/img/slider/hero-4.png"
                        alt
                        data-animation="fadeInRight"
                        data-delay=".25s"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
}

function MobileSlider() {
  return (
    <>
      <div class="hero-single">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-md-12 col-lg-6">
              <div class="hero-content">
                <h6
                  class="hero-sub-title"
                  data-animation="fadeInUp"
                  data-delay=".25s"
                >
                  Buy with Confidence!
                </h6>
                <h1
                  class="hero-title"
                  data-animation="fadeInRight"
                  data-delay=".50s"
                >
                  Get Dealer-Level Access To Used Car Auctions
                </h1>
                <p data-animation="fadeInLeft" data-delay=".75s">
                  Let’s help you Buy, Ship and Clear your dream car at a
                  fraction of the retail cost.
                </p>
                <div class="hero-btn" data-animation="fadeInUp" data-delay="1s">
                  <a href="#" class="theme-btn">
                    About More<i class="fas fa-arrow-right-long"></i>
                  </a>
                  <a href="#" class="theme-btn theme-btn2">
                    Learn More<i class="fas fa-arrow-right-long"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="hero-right">
                <div class="hero-img">
                  <img
                    src="/assets/img/slider/hero-4.png"
                    alt
                    data-animation="fadeInRight"
                    data-delay=".25s"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const MainSlider = () => {
  return (
    <>
      <div className="container-fluid d-md-block d-none">
        <DesktopSlider />
      </div>
      <div className="container-fluid d-md-none d-block mt-120">
        <MobileSlider />
      </div>
    </>
  );
};

export default MainSlider;
